/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { RectData } from "igniteui-react-core";
import { GridLayerExport } from "./GridLayerExport";
import { List$1 } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var VisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VisualModelExport, _super);
    function VisualModelExport() {
        var _this = _super.call(this) || this;
        _this.ae = null;
        _this.ah = 0;
        _this.ag = 0;
        _this.an = 0;
        _this.am = 0;
        _this.ak = 0;
        _this.al = 0;
        _this.ai = 0;
        _this.aq = 0;
        _this.ar = 0;
        _this.as = 0;
        _this.ap = 0;
        _this.ao = 0;
        _this.at = 0;
        _this.x = null;
        _this.a = null;
        _this.aa = null;
        _this.b = null;
        _this.r = null;
        _this.q = null;
        _this.s = null;
        _this.h = null;
        _this.c = null;
        _this.k = null;
        _this.f = null;
        _this.g = null;
        _this.w = null;
        _this.u = null;
        _this.t = null;
        _this.v = null;
        _this.z = null;
        _this.y = null;
        _this.o = null;
        _this.n = null;
        _this.ac = null;
        _this.ab = null;
        _this.j = null;
        _this.i = null;
        _this.e = null;
        _this.d = null;
        _this.m = null;
        _this.l = null;
        _this.ad = null;
        _this.p = null;
        _this.aj = 0;
        _this.af = null;
        _this.au = 0;
        _this.ae = RectData.empty;
        _this.x = new GridLayerExport("SubContentLayer");
        _this.a = new GridLayerExport("ContentLayer");
        _this.aa = new GridLayerExport("SuperContentLayer");
        _this.b = new GridLayerExport("DecoratorLayer");
        _this.r = new GridLayerExport("PinnedRowsSubLayer");
        _this.q = new GridLayerExport("PinnedRowsLayer");
        _this.s = new GridLayerExport("PinnedRowsSuperLayer");
        _this.h = new GridLayerExport("FixedSubContentLayer");
        _this.c = new GridLayerExport("FixedContentLayer");
        _this.k = new GridLayerExport("FixedSuperContentLayer");
        _this.f = new GridLayerExport("FixedPinnedRowsLayer");
        _this.g = new GridLayerExport("FixedSeparatorLayer");
        _this.w = new GridLayerExport("SectionLayer");
        _this.u = new GridLayerExport("PinnedSectionSubLayer");
        _this.t = new GridLayerExport("PinnedSectionLayer");
        _this.v = new GridLayerExport("PinnedSectionSuperLayer");
        _this.z = new GridLayerExport("SubHeaderLayer");
        _this.y = new GridLayerExport("SubHeaderDecoratorLayer");
        _this.o = new GridLayerExport("HeaderLayer");
        _this.n = new GridLayerExport("HeaderDecoratorLayer");
        _this.ac = new GridLayerExport("SuperHeaderLayer");
        _this.ab = new GridLayerExport("SuperHeaderDecoratorLayer");
        _this.j = new GridLayerExport("FixedSubHeaderLayer");
        _this.i = new GridLayerExport("FixedSubHeaderDecoratorLayer");
        _this.e = new GridLayerExport("FixedHeaderLayer");
        _this.d = new GridLayerExport("FixedHeaderDecoratorLayer");
        _this.m = new GridLayerExport("FixedSuperHeaderLayer");
        _this.l = new GridLayerExport("FixedSuperHeaderDecoratorLayer");
        _this.ad = new GridLayerExport("VerticalSeparatorLayer");
        _this.p = new GridLayerExport("HiddenLayer");
        _this.aj = 1;
        return _this;
    }
    VisualModelExport.prototype.ax = function () {
        this.af = new List$1(GridLayerExport.$, 0);
        this.af.add(this.x);
        this.af.add(this.a);
        this.af.add(this.aa);
        this.af.add(this.b);
        this.af.add(this.r);
        this.af.add(this.q);
        this.af.add(this.s);
        this.af.add(this.h);
        this.af.add(this.c);
        this.af.add(this.k);
        this.af.add(this.f);
        this.af.add(this.g);
        this.af.add(this.w);
        this.af.add(this.u);
        this.af.add(this.t);
        this.af.add(this.v);
        this.af.add(this.z);
        this.af.add(this.y);
        this.af.add(this.o);
        this.af.add(this.n);
        this.af.add(this.ac);
        this.af.add(this.ab);
        this.af.add(this.j);
        this.af.add(this.i);
        this.af.add(this.e);
        this.af.add(this.d);
        this.af.add(this.m);
        this.af.add(this.l);
        this.af.add(this.ad);
    };
    VisualModelExport.prototype.aw = function () {
        this.x.f();
        this.a.f();
        this.aa.f();
        this.b.f();
        this.r.f();
        this.q.f();
        this.s.f();
        this.h.f();
        this.c.f();
        this.k.f();
        this.f.f();
        this.g.f();
        this.w.f();
        this.u.f();
        this.t.f();
        this.v.f();
        this.z.f();
        this.y.f();
        this.o.f();
        this.n.f();
        this.ac.f();
        this.ab.f();
        this.j.f();
        this.i.f();
        this.e.f();
        this.d.f();
        this.m.f();
        this.l.f();
        this.ad.f();
    };
    VisualModelExport.prototype.av = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("top : " + this.as + ", ");
        a.l("left : " + this.ap + ", ");
        a.l("height : " + this.ao + ", ");
        a.l("width : " + this.at + ", ");
        a.l("absoluteWidth : " + this.ah + ", ");
        a.l("absoluteHeight : " + this.ag + ", ");
        a.l("headerHeight : " + this.an + ", ");
        a.l("fixedRowHeight : " + this.am + ", ");
        a.l("fixedColumnWidthLeft : " + this.ak + ", ");
        a.l("fixedColumnWidthRight : " + this.al + ", ");
        a.l("dipScalingRatio: " + this.aj + ", ");
        a.l("columnSpacing : " + this.ai + ", ");
        a.l("separatorLeft : " + this.aq + ", ");
        a.l("separatorRight : " + this.ar + ", ");
        for (var b = 0; b < this.af.count; b++) {
            var c = this.af._inner[b].c.charAt(0).toString().toLowerCase() + this.af._inner[b].c.substr(1);
            a.l(c + ": " + this.af._inner[b].d() + ", ");
        }
        a.l("actualVisibleRegion: { left: " + this.ae.left + ", top: " + this.ae.top + ", width: " + this.ae.width + ", height: " + this.ae.height + "}");
        a.l("}");
        return a.toString();
    };
    VisualModelExport.$t = markType(VisualModelExport, 'VisualModelExport');
    return VisualModelExport;
}(Base));
export { VisualModelExport };
//# sourceMappingURL=VisualModelExport.js.map
